import { Eye, ShieldCheck } from 'lucide-react';
import { HUB_URL } from '@/lib/clerkSso';
import { useFermerIntervention, useLancerDemo, usePlateforme, useQuitterDemo } from '@/api/platform';

/**
 * LOT_ROLES_HUB / LOT_DEMO — bandeau permanent au-dessus de l'application quand on
 * n'est pas chez soi : l'équipe en intervention (on agit au nom d'un titulaire),
 * ou un commercial dans la démo (rien n'est conservé). Impossible à rater, c'est
 * le garde-fou contre la saisie dans le mauvais dossier.
 */
export default function PlatformBanner() {
  const { data: p } = usePlateforme();
  const fermer = useFermerIntervention();
  const relancer = useLancerDemo();
  const quitter = useQuitterDemo(`${HUB_URL}/commercial`);

  if (p?.intervention) {
    return (
      <div className="flex items-center gap-3 px-5 py-2 text-[13px] text-white bg-amber-700">
        <ShieldCheck size={16} className="flex-shrink-0" />
        <div className="flex-1 min-w-0 truncate">
          <strong>INTERVENTION</strong>
          <span className="mx-2 opacity-60">•</span>
          <strong>{p.intervention.pharmacy.name}</strong>
          <span className="mx-2 opacity-60">•</span>
          <span className="opacity-90">{p.intervention.reason}</span>
          <span className="ml-2 text-[11px] opacity-75">(vous agissez comme le titulaire — tout est tracé)</span>
        </div>
        <a href="/console" className="px-3 py-1 rounded-md bg-white/15 hover:bg-white/25 text-[12px] font-semibold">
          Console
        </a>
        <button
          onClick={() => fermer.mutate()}
          disabled={fermer.isPending}
          className="px-3 py-1 rounded-md bg-white text-amber-800 hover:bg-white/90 text-[12px] font-semibold disabled:opacity-50"
        >
          {fermer.isPending ? 'Fermeture…' : "Terminer l'intervention"}
        </button>
      </div>
    );
  }

  if (p?.role === 'COMMERCIAL' && p.demo?.active) {
    return (
      <div className="flex items-center gap-3 px-5 py-2 text-[13px] text-white" style={{ backgroundColor: '#0B5F52' }}>
        <Eye size={16} className="flex-shrink-0" />
        <div className="flex-1 min-w-0 truncate">
          <strong>MODE DÉMONSTRATION</strong>
          <span className="mx-2 opacity-60">•</span>
          <strong>Pharmacie du Bourg</strong>
          <span className="ml-2 text-[11px] opacity-75">(données fictives, rien n'est conservé)</span>
        </div>
        <button
          onClick={() => {
            if (window.confirm("Repartir d'une démo neuve ? Tout ce que vous avez fait sera effacé.")) relancer.mutate();
          }}
          disabled={relancer.isPending || quitter.isPending}
          className="px-3 py-1 rounded-md bg-white/15 hover:bg-white/25 text-[12px] font-semibold disabled:opacity-50"
        >
          {relancer.isPending ? 'Préparation…' : 'Recommencer'}
        </button>
        <button
          onClick={() => quitter.mutate()}
          disabled={relancer.isPending || quitter.isPending}
          className="px-3 py-1 rounded-md bg-white hover:bg-white/90 text-[12px] font-semibold disabled:opacity-50"
          style={{ color: '#0B5F52' }}
        >
          {quitter.isPending ? 'Fermeture…' : 'Quitter la démo'}
        </button>
      </div>
    );
  }

  return null;
}
